
import {
  Component, Vue, Watch,
} from 'nuxt-property-decorator'
import BaseIcon from './base/BaseIcon.vue'
import { IToolBarElement } from '../shared/general/interfaces/IToolbarElement'
import { trackBackToTop } from '../shared/general/tracking/TrackingService'
import { globalLabelAsString } from '../shared/general/services/StoreService'

@Component({
  name: 'BackToTop',
  components: {
    BaseIcon,
  },
})
export default class BackToTop extends Vue {
  private toolbarHasElements : boolean = false

  private toolbarHasLocation : boolean = false

  private visible : boolean = false

  private lastScrollY : number = 0

  private scrollDirection : 'up' | 'down' | 'none' = 'down'

  mounted () {
    window.addEventListener('scroll', this.handleScroll)
  }

  private handleScroll () : void {
    if (window.scrollY === 0) {
      this.visible = false
      return
    }

    const currentScrollY = window.scrollY

    if (currentScrollY > this.lastScrollY) {
      this.scrollDirection = 'down'
    } else if (currentScrollY < this.lastScrollY) {
      this.scrollDirection = 'up'
    } else {
      this.scrollDirection = 'none'
    }

    // We need to check if the user scrolled more than 20% of the viewport height
    const viewportHeight = window.innerHeight
    const twoVh = viewportHeight * 0.02

    if (currentScrollY > twoVh && this.scrollDirection === 'up') {
      this.visible = true
    } else if (this.scrollDirection === 'down') {
      this.visible = false
    }

    this.lastScrollY = currentScrollY
  }

  private backToTop () : void {
    trackBackToTop(this.$el as HTMLElement)
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    })
  }

  @Watch('$store.state.ToolbarElements.elements', { deep: true, immediate: true })
  private checkToolbarHasElements (currentElements : IToolBarElement[]) : void {
    this.toolbarHasElements = !!currentElements.length
  }

  @Watch('$store.state.ToolbarElements.showLocationSidebarElement', { deep: true, immediate: true })
  private checkToolbarHasLocation (showLocationSidebarElement : boolean) : void {
    this.toolbarHasLocation = showLocationSidebarElement
  }

  private get isToolbarVisible () {
    return this.toolbarHasElements || this.toolbarHasLocation
  }

  private get backToTopLabel () {
    return globalLabelAsString('back_to_top_label')
  }

  destroyed () {
    window.removeEventListener('scroll', this.handleScroll)
  }
}
